import { render, staticRenderFns } from "./ProductSelectProductProviderForm.vue?vue&type=template&id=473eda67&scoped=true"
import script from "./ProductSelectProductProviderForm.vue?vue&type=script&lang=js"
export * from "./ProductSelectProductProviderForm.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectProductProviderForm.vue?vue&type=style&index=0&id=473eda67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473eda67",
  null
  
)

export default component.exports